import axios from '../../../../shared/axios';

import * as actionTypes from '../constants/ring-central';

import { AppDispatch } from '../../../../store';
import { validateObj } from '../../../../shared/utils';

import { DeleteRingCentralAccountRequest, RingCentralAccount, SaveRingCentralAccountRequest } from '../../models';

const getRingCentralAccountSettingsStart = () => {
  return {
    type: actionTypes.RING_CENTRAL_GET_RING_CENTRAL_SETTINGS_START,
  };
};

const getRingCentralAccountSettingsSuccess = (data: RingCentralAccount) => {
  return {
    type: actionTypes.RING_CENTRAL_GET_RING_CENTRAL_SETTINGS_SUCCESS,
    data,
  };
};

const getRingCentralAccountSettingsFail = (error: any) => {
  return {
    type: actionTypes.RING_CENTRAL_GET_RING_CENTRAL_SETTINGS_FAIL,
    error,
  };
};

export const getRingCentralAccountSettings = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<RingCentralAccount>((resolve, reject) => {
      dispatch(getRingCentralAccountSettingsStart());

      const url = `/ring-central/get-ring-central-account`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getRingCentralAccountSettingsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getRingCentralAccountSettingsFail(err));
          reject(err);
        });
    });
  };
};

const saveRingCentralAccountSettingsStart = () => {
  return {
    type: actionTypes.RING_CENTRAL_SAVE_RING_CENTRAL_ACCOUNT_SETTINGS_START,
  };
};

const saveRingCentralAccountSettingsSuccess = (data: boolean) => {
  return {
    type: actionTypes.RING_CENTRAL_SAVE_RING_CENTRAL_ACCOUNT_SETTINGS_SUCCESS,
    data,
  };
};

const saveRingCentralAccountSettingsFail = (error: any) => {
  return {
    type: actionTypes.RING_CENTRAL_SAVE_RING_CENTRAL_ACCOUNT_SETTINGS_FAIL,
    error,
  };
};

export const saveRingCentralAccountSettings = (params: SaveRingCentralAccountRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(saveRingCentralAccountSettingsStart());

      const url = `/ring-central/save-ring-central-account`;

      axios
        .post(url, validateObj(params))
        .then((response) => {
          dispatch(saveRingCentralAccountSettingsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveRingCentralAccountSettingsFail(err));
          reject(err);
        });
    });
  };
};

const removeRingCentralAccountStart = () => {
  return {
    type: actionTypes.RING_CENTRAL_REMOVE_RING_CENTRAL_ACCOUNT_START,
  };
};

const removeRingCentralAccountSuccess = (data: boolean) => {
  return {
    type: actionTypes.RING_CENTRAL_REMOVE_RING_CENTRAL_ACCOUNT_SUCCESS,
    data,
  };
};

const removeRingCentralAccountFail = (error: any) => {
  return {
    type: actionTypes.RING_CENTRAL_REMOVE_RING_CENTRAL_ACCOUNT_FAIL,
    error,
  };
};

export const removeRingCentralAccount = (params: DeleteRingCentralAccountRequest) => {
  return (dispatch: AppDispatch) => {
    return new Promise<boolean>((resolve, reject) => {
      dispatch(removeRingCentralAccountStart());

      const url = `/ring-central/delete-ring-central-account`;

      axios
        .delete(url, { params: validateObj(params) })
        .then((response) => {
          dispatch(removeRingCentralAccountSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(removeRingCentralAccountFail(err));
          reject(err);
        });
    });
  };
};

const getAllRingCentralPhonesStart = () => {
  return {
    type: actionTypes.RING_CENTRAL_GET_ALL_RING_CENTRAL_PHONES_START,
  };
};

const getAllRingCentralPhonesSuccess = (data: Array<string>) => {
  return {
    type: actionTypes.RING_CENTRAL_GET_ALL_RING_CENTRAL_PHONES_SUCCESS,
    data,
  };
};

const getAllRingCentralPhonesFail = (error: any) => {
  return {
    type: actionTypes.RING_CENTRAL_GET_ALL_RING_CENTRAL_PHONES_FAIL,
    error,
  };
};

export const getAllRingCentralPhones = () => {
  return (dispatch: AppDispatch) => {
    return new Promise<Array<string>>((resolve, reject) => {
      dispatch(getAllRingCentralPhonesStart());

      const url = `/ring-central/get-ring-central-phones`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getAllRingCentralPhonesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getAllRingCentralPhonesFail(err));
          reject(err);
        });
    });
  };
};

export const setAllRingCentralPhones = (value: Array<string>) => {
  return (dispatch: AppDispatch) => {
    dispatch({
      type: actionTypes.RING_CENTRAL_SET_ALL_RING_CENTRAL_PHONES,
      data: value,
    });
  };
};
